import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    standalone: true,
})
export class TagComponent {
    private _baseColour?: string;
    private _variant?: string;

    /* eslint-disable @typescript-eslint/naming-convention */
    private textColourVariants = {
        light: 'dark-active',
        'light-active': 'dark-active',
        'normal': 'light',
        'dark': 'light',
        'dark-active': 'light'
    }
    /* eslint-enable @typescript-eslint/naming-convention */

    private _colour: string;
    get colour() {
        return this._colour;
    }

    @Input() set colour(value: string) {
        this._colour = value;
        const splitIndex = value.indexOf('-');
        this._baseColour = value.split('-', 1)[0];
        this._variant = value.slice(splitIndex + 1);
    }

    @HostBinding('style') get styles() {
        return {
            backgroundColor: `var(--colour-${this._baseColour}-${this._variant})`,
            boxShadow: `inset 0 0 0 1px var(--colour-${this._baseColour}-normal)`,
            color: `var(--${this.textColourClass})`
        }
    }

    get textColourClass() {
        return `colour-${this._baseColour}-${this.textColourVariants[this._variant]}`
    }

}
